import {Injectable} from '@angular/core';
import {EntityStoreService} from '../modules/akita-mimic/services/entity-store.service';
import {UserGroupState} from '../modules/akita-mimic/models/store-states/user-group-state.model';
import {UserGroup} from '../api/models/user-group';

@Injectable({ providedIn: 'root' })
export class UserGroupStore extends EntityStoreService<UserGroupState, UserGroup> {
    public constructor() {
        super('userGroup', {
            active: [],
            entities: {},
            ids: [],
            loading: false,
            member: []
        });
    }
}
